import uiRouter, { StateProvider } from '@uirouter/angularjs';
import angular from 'angular';

export const SherpaCustomersOrdersDetailView = angular
  .module('acme.view.application.sherpa.customers.orders.detail', [
    uiRouter,
    'ui.bootstrap',
    'acme.view.application.sherpa.customers.orders.detail.controllers',
    'acme.common.directive.detailList',
    'acme.common.directive.resendEmail',
  ])
  .config(function config($stateProvider: StateProvider) {
    $stateProvider.state({
      name: 'application.sherpa.customers.ordersDetail',
      url: '/orders/:id/detail/:orderId?type',
      views: {
        'subview-main': {
          controller: 'SherpaCustomersOrdersDetailController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/sherpa/customers/orders/detail/detail.tpl.html',
        },
      },
      data: {
        pageTitle: 'Order Refund',
      },
    });
  }).name;
